<template>
  <v-container fluid fill-height class="container-text pa-0" style="overflow: hidden; position: relative; resize: none">
    <editor-content :editor="editor" @keydown.space.native="spaceHack" spellcheck="false" />
  </v-container>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Placeholder from '@tiptap/extension-placeholder'
import Commands from '../template/commands'
import suggestion from '../template/suggestion'

export default {
  name: 'RecordScript',
  components: {
    EditorContent,
  },
  props: {},
  created() {},
  mounted() {
    this.editor = new Editor({
      content: '',
      // editable: true,
      // scrollIntoView: 'false',
      parseOptions: {
        preserveWhitespace: 'full',
      },
      extensions: [
        StarterKit,
        Placeholder.configure({
          emptyEditorClass: 'is-editor-empty',
          placeholder: 'Type "/" for commands',
        }),
        Commands.configure({
          suggestion,
        }),
      ],
      onUpdate: () => {},
    })
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  data() {
    return {
      editor: null,
      editorble: null,
    }
  },
  methods: {
    // 스페이스바가 안 먹는 기현상을 해결하기 위한 핵
    spaceHack(e) {
      e.stopPropagation()
    },
  },
  watch: {
    content(value) {
      // HTML
      const isSame = this.editor.getHTML() === value
      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)
      if (isSame) {
        return
      } else {
        this.editor.commands.setContent(value)
      }
    },
  },
}
</script>

<style scoped></style>
